import React, {useEffect, useState} from "react";
import Jwplayer from "../Components/Jwplayer";
import BoxAds from "../Components/BoxAds";
import {fetchMovieDetail, fetchVideoIframe, playVideo} from "./Components/requesApi";
import AppConstants from "../../Config/AppConstants";
import MetaTags from "react-meta-tags";
import NotFound from "../Components/NotFound";

let callBack = 0;
function IframeVideo (props) {
    const [movie, setDataMovie] = useState(null);
    const [error, setError] = useState(0);
    useEffect(() => {
        document.getElementsByClassName('sidebar')[0].setAttribute("style", "display:none;");
        document.getElementsByClassName('header-mobile')[0].setAttribute("style", "display:none;");
        document.getElementsByClassName('overlay')[0].setAttribute("style", "display:none;");
        document.getElementById('footer').setAttribute("style", "display:none;");
    }, []);

    useEffect(async () => {
        let result = await fetchVideoIframe(props.match.params.alias);
        if (!result || result.status != 200 || !result.data.data) {
            setError(1);
            setDataMovie(null);
            return false;
        }
        window.scrollTo(0, 0);
        setDataMovie(result.data.data);
    }, []);

    if(error == 1) {
        return <NotFound/>

    }
    if (!movie) {
        return <></>
    }

   // let movie = JSON.parse('{"id":13366,"name":"FC2PPV 3197203 A Naive Boxed Lady Into Vaginal Cum Shot Twice","slug":"fc2ppv-3197203","driver_id":0,"duration":"1:10:28","quality":"3","view":748,"like":0,"published":"2023-03-07","storeID":1,"path":"","file_code":"","contents":null,"image":"https://image-funlove.b-cdn.net/videos/2023/03/07-03-2023/hXC215vMkK.jpg","sources":[{"name":"DB","file":"http://funlove.test/api/path-video/13366/DB/8124b9ae4749312d2b62f3f317963fd6/1678304419/file.mp4","type":"video/mp4","label":720,"typePlay":2,"active":1},{"name":"SB","ulr":"https://sbfull.com/e/e9kj5as4bn0f.html?poster=https://image-funlove.b-cdn.net/videos/2023/03/07-03-2023/hXC215vMkK.jpg","active":0,"typePlay":1},{"name":"FL","file":"http://funlove.test/api/path-video/13366/FL/52a7105564df43e240aab6681b65a71d/1678304419/file.mp4","type":"video/mp4","label":720,"typePlay":2,"active":0}]}');
   // console.log(data);
    const onPlayVideo = () => {
        //playVideo(movie.id);
    }
    return <>
        <MetaTags>
            <title> {movie.name}</title>
            <meta name="description"
                  content={`${movie.name} jav free fc2ppv Xnxx JAVHD Xvideos Pornhub XXX Uncensored `}/>
            <meta name="robots" content={movie.name +"Uncensored, jav free, javhd, XXX, Xnxx, fc2, Xvideos, fc2ppv, japanese av, asian porn, japanese porn, porn hd, free hd porn, china porn, asian sex, adults"}/>
            <meta name="keywords" content={movie.name +" Uncensored, jav free, javhd, XXX, Xnxx, fc2, Xvideos, fc2ppv, japanese av, asian porn, japanese porn, porn hd, free hd porn, china porn, asian sex, adults"}/>
            <meta property="og:keywords" content={movie.name+" Watch Free Uncensored, jav, javhd, XXX, Xnxx, fc2, Xvideos, fc2ppv, japanese av, asian porn, japanese porn, porn hd, free hd porn, china porn, asian sex, adults"}/>
            <link rel="canonical" href={`${AppConstants.domainPage}movie/${movie.name}`}/>
            <meta property="og:locale" content="en_us"/>
            <meta property="og:type" content="website"/>
            <meta property="og:title" content={`${movie.name}`}/>
            <meta property="og:description" content={`${movie.name} jav free fc2ppv Xnxx JAVHD Xvideos Pornhub XXX Uncensored`}/>
            <meta property="og:url" content={`${AppConstants.domainPage}movie/${movie.slug}`}/>
            <meta property="og:site_name" content={AppConstants.pageName}/>

            <meta property="og:updated_time" content={movie.published}/>
            <meta property="og:image" content={movie.image}/>
            <meta property="og:image:secure_url" content={movie.image}/>
            <meta property="og:image:width" content="480"/>
            <meta property="og:image:height" content="270"/>
            <meta property="og:image:alt" content={movie.name}/>
            <meta property="og:image:type" content="image/jpeg"/>

            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:title" content={movie.name}/>
            <meta name="twitter:description" content={`jav free fc2ppv Xnxx JAVHD Xvideos Pornhub XXX Uncensored ${movie.name}`}/>
            <meta name="twitter:site" content={`@${AppConstants.pageName}`}/>
            <meta name="twitter:creator" content={`@${AppConstants.pageName}`}/>
            <meta name="twitter:image" content={movie.image}/>
        </MetaTags>
        <div className='iframe-video'>
            <div className="player-wrapper">
                <Jwplayer sources={movie.sources} image={movie.image} keyID={movie.id} onPlayVideo={onPlayVideo}/>
            </div>
            <BoxAds></BoxAds>
            <BoxAds></BoxAds>
            <h1 className="title-iframe">{movie.name}</h1>
        </div>
    </>
}

export default IframeVideo;